/* NgRx */
import {createAction, props} from '@ngrx/store';

/******** CLEAR STATE ***********/
const CLEAR_STATE = '[client user] clear state';
export const ClearState = createAction(CLEAR_STATE);
